import { ONE_MINUTE_MS } from './datetimeUtils'

/**
 * Opens an HTML string in a new browser tab via an in-memory blob URL.
 *
 * Used by surfaces that receive raw HTML content from the backend (privacy
 * policy, terms & conditions) and need to render it in a fresh document
 * without injecting it into the current DOM.
 *
 * The blob URL is revoked after `ONE_MINUTE_MS` so memory doesn't grow when
 * the user opens documents repeatedly. Revoking sooner would risk killing
 * the URL before the browser finishes loading it; later is harmless.
 */
export const openHtmlInNewTab = (htmlContent: string): void => {
  const htmlBlob = new Blob([htmlContent], { type: 'text/html' })
  const htmlUrl = URL.createObjectURL(htmlBlob)
  window.open(htmlUrl, '_blank')
  window.setTimeout(() => URL.revokeObjectURL(htmlUrl), ONE_MINUTE_MS)
}
